define('imovelusuario-controller',[
    'directive/ng-flow/dist/ng-flow-standalone.min',
    'directive/flow.js/dist/flow.min',
    'directive/ng-flow/dist/ng-flow.min',
    'imovelusuario-resource',
    'imovel-resource',
    'angular-file-upload',
    // 'lib/resize',
], function() {

    var app = angular.module('imovelusuario.controller', [
        'imovelusuario.resource',
        'imovel.resource',
        'flow',
    ]);

    app.controller('ImovelusuarioControllerIndex', ['$scope', '$rootScope', 'Imovelusuario', function($scope, $rootScope, Imovelusuario) {
        $scope.imoveis = null;

        $scope.getImoveis = function(){
            Imovelusuario.getImoveis({}).then(function (response) {
                $scope.imoveis = response.data;
            }).catch(function (error) {
                console.error(error);
            });
        };

        $scope.getImoveis();

    }]);

    app.controller('ImovelusuarioControllerAdd', ['$scope', '$rootScope','Imovel', 'Imovelusuario','$selectUIService', function($scope, $rootScope, Imovel, Imovelusuario, $selectUIService) {
        $scope.estados = estados;
        $scope.selectedEstado = null;
        $scope.cidades = [];
        $scope.tipoCadastro = tipoCadastro;
        $scope.selectedCidade = null;
        $scope.selectedTipoCadastro = null;
        $scope.selectedTipoNegocio = null;
        $scope.imovel = null;

        $scope.imovelUsuario = {
            imou_nome_cliente: null,
            imou_numero: null,
            imou_bairro: null,
            imou_endereco: null,
            imou_complemento: null,
            tic_codigo: null,
            cid_codigo: null,
            imou_is_locacao: null,
            imou_is_venda: null,
            imou_preco_locacao: null,
            imou_preco_venda: null,
        };

        $scope.totalFiles = 0;
        $scope.limiteDeUpload = 10;
        $scope.submitFlow =  function($flow) {
            $scope.totalFiles = $flow.files.length; // limitando upload de arquivos
            if($scope.totalFiles > $scope.limiteDeUpload){
                //removendo fotos até chegar no número permitido
                for(var i = $flow.files.length; i > $scope.limiteDeUpload; i--){
                    $flow.files.pop(); // removendo ultimo arquivo
                }
                $scope.totalFiles = $scope.limiteDeUpload;
            }
            $flow.opts.target = '/areacliente/imovelusuario/uploadImg/'+$scope.imovel.imou_codigo;
            $flow.upload();
        };

        $scope.steps = {
            first: "infos",
            second: "pictures",
            last: "last"
        };
        $scope.step = $scope.steps.first;

        $scope.setModel = function(model, value){
            $scope[model] = value;
        };

        $scope.addUpload = function(item){
            $scope.uploadSlider = item;
        }
        $scope.uploadImg  = function(files, errFiles, $flow) {
            $("#ajaxbloq").remove();
            if(files != null && files.length > 0){
                $("body").append($("#ajaxbloqSrc").html());
                setTimeout(function() {
                    files.map(function (file, idx) {
                        $flow.addFile(file);
                        // $flow.upload();
                    });
                    $("#ajaxbloq").remove();
                    //
                }, 1000);
            }
        };

        $scope.sucessUploadImg =  function (file, $message, $flow ) {
            var $self = $('.flow-file-'+file.uniqueIdentifier);
            // Reflect that the file upload has completed
            $self.find('.flow-file-complete span').text('Completo');
            $self.find('.flow-file-pause').hide();
            $self.find('.flow-file-cancel').hide();
            $scope.flowReset = $flow;
            var data = {
                imou_codigo: $scope.imovel.imou_codigo,
                file: {
                    name:file.file.name,
                    type:file.file.type,
                    identifier:file.uniqueIdentifier
                }
            };
            Imovelusuario.successUploadImgImovelusuario(data).then(function(result){
                $scope.totalFiles--;
                if($scope.totalFiles == 0){
                    $scope.step = $scope.steps.last;
                    alert('Cadastro de imóvel concluído !');
                    window.location.href = '/areacliente/imovelusuario/';
                }
            });
        };

        $scope.setTipoNegocio = function(tipo){

        };

        $scope.getCidadeByEstado = function (estado){
            if(estado != null){
                Imovelusuario.getCidadeByEstado(estado).then(function (response) {
                    $scope.cidades = response;
                }).catch(function (error) {
                    console.error(error);
                });
            }else{
                alert('Selecione o estado !');
            }
        };

        $scope.save = function(){

            $scope.imovelUsuario.tic_codigo = $scope.selectedTipoCadastro;
            $scope.imovelUsuario.cid_codigo = $scope.selectedCidade;

            if($scope.selectedTipoNegocio == 'VENDA'){
                $scope.imovelUsuario.imou_is_locacao = false;
                $scope.imovelUsuario.imou_is_venda = true;
            }
            if($scope.selectedTipoNegocio == 'LOCACAO'){
                $scope.imovelUsuario.imou_is_locacao = true;
                $scope.imovelUsuario.imou_is_venda = false;
            }
            if($scope.selectedTipoNegocio == 'VENDALOCACAO'){
                $scope.imovelUsuario.imou_is_locacao = true;
                $scope.imovelUsuario.imou_is_venda = true;
            }

            Imovelusuario.create($scope.imovelUsuario).then(function (response) {
                $scope.imovel = response.imovelusuario;
                $scope.step = $scope.steps.second;
            }).catch(function (error) {
                console.error(error);
            });
        };

    }]);

    app.config(['flowFactoryProvider',    function(flowFactoryProvider) {
        flowFactoryProvider.defaults = {
            //dynamic target:'/imobiliaria-layout/uploadImg',
            permanentErrors: [404, 500, 501],
            testChunks: false,
            simultaneousUploads: 1,
        };
        function readablizeBytes(bytes) {
            var s = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
            var e = Math.floor(Math.log(bytes) / Math.log(1024));
            return (bytes / Math.pow(1024, e)).toFixed(2) + " " + s[e];
        }


        function secondsToStr (temp) {
            function numberEnding (number) {
                return (number > 1) ? 's' : '';
            }
            var years = Math.floor(temp / 31536000);
            if (years) {
                return years + ' year' + numberEnding(years);
            }
            var days = Math.floor((temp %= 31536000) / 86400);
            if (days) {
                return days + ' day' + numberEnding(days);
            }
            var hours = Math.floor((temp %= 86400) / 3600);
            if (hours) {
                return hours + ' hour' + numberEnding(hours);
            }
            var minutes = Math.floor((temp %= 3600) / 60);
            if (minutes) {
                return minutes + ' minute' + numberEnding(minutes);
            }
            var seconds = temp % 60;
            return seconds + ' second' + numberEnding(seconds);
        }

        flowFactoryProvider.on('fileProgress', function(file){
            // Handle progress for both the file and the overall upload
            var $self = $('.flow-file-'+file.uniqueIdentifier);
            $self.find('.progress-bar').css({width:Math.floor(file.progress()*100) + '%'});
            $self.find('.flow-file-porcentagem').text(Math.floor(file.progress()*100) + '%');
            $self.find('.flow-file-pause').show();
            $self.find('.flow-file-time').text('Tempo:' + readablizeBytes(file.averageSpeed) + '/s '
                + secondsToStr(file.timeRemaining()) + '');
            $self.find('.flow-file-download').attr('href', '/validacao/download/' + file.uniqueIdentifier).hide();

            $self.find('.flow-file-pause').on('click', function () {
                file.pause();
                $self.find('.flow-file-pause').hide();
                $self.find('.flow-file-resume').show();
            });

            $self.find('.flow-file-resume').on('click', function () {
                file.resume();
                $self.find('.flow-file-pause').show();
                $self.find('.flow-file-resume').hide();
            });

            $self.find('.flow-file-cancel').on('click', function () {
                file.cancel();
                $self.remove();
            });

        });


        flowFactoryProvider.on('fileError', function(file, message){
            // Reflect that the file upload has resulted in error
            var $self = $('.flow-file-'+file.uniqueIdentifier);
            $self.find('.flow-file-complete span').text('Erro: '+message+'');
            $self.find('.flow-file-resume').show();
        });

    }]);

});

